import React, { Component } from 'react';
import { Button, Col, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import { orderBy } from 'lodash';
import { connect } from 'react-redux';
import Breadcrumbs from '../components/Breadcrumb';
import { getEpikBoxesData, getEpikBoxesDetail, getLocationByCompany } from '../actions/EpikBoxes';
import { generateReport, getCompanyGroups } from '../actions/Reports';
import ReportListTable from '../components/EpikBoxes/BoxList/ReportListTable';
import WithUserData from '../HOC/withUserData';
import PortActivationModal from '../components/PortActivationModal';
import { getCompanies } from '../actions/Companies';

const reportsList = [
  // {
  //   reportName: 'Port Activation Details',
  //   owner: 'System',
  //   sharingStatus: 'Shared',
  //   dateRange: true,
  //   includeSummary: true,
  //   reportSymbol: 'PAD',
  // },
  {
    reportName: 'DID Assignment',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: false,
    includeSummary: false,
    reportSymbol: 'DID',
    alarmProtocol: false,
  },
  // {
  //   reportName: 'e911 Enabled',
  //   owner: 'System',
  //   sharingStatus: 'Shared',
  //   dateRange: false,
  //   includeSummary: false,
  //   reportSymbol: '911',
  //   alarmProtocol: false,
  // },
  {
    reportName: 'Unregistered Edge Devices',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: true,
    includeSummary: false,
    reportSymbol: 'BOL',
    alarmProtocol: false,
  },
  {
    reportName: 'Temp DID',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: false,
    includeSummary: false,
    reportSymbol: 'TDID',
    alarmProtocol: false,
  },
  {
    reportName: 'Line Type',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: true,
    includeSummary: false,
    reportSymbol: 'LT',
    alarmProtocol: false,
  },
  {
    reportName: 'Alarm Protocol Relay',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: true,
    includeSummary: false,
    reportSymbol: 'APR',
    alarmProtocol: true,
  },
  {
    reportName: 'EPIs in Alert State',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: false,
    includeSummary: false,
    reportSymbol: 'BAD',
    alarmProtocol: false,
  },
  {
    reportName: 'Portal Assets',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: false,
    includeSummary: false,
    reportSymbol: 'PAR',
    alarmProtocol: false,
  },
  {
    reportName: 'Data Center',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: false,
    includeSummary: false,
    reportSymbol: 'DAR',
    alarmProtocol: false,
  },
  {
    reportName: 'EPIK Edge Device Integration',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: false,
    includeSummary: false,
    reportSymbol: 'EDI',
    alarmProtocol: false,
  },
  {
    reportName: 'Network Summary',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: false,
    includeSummary: false,
    reportSymbol: 'NSR',
    alarmProtocol: false,
  },
  {
    reportName: 'EPI Firmware Report',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: false,
    includeSummary: false,
    reportSymbol: 'AFR',
    alarmProtocol: false,
  },
  {
    reportName: 'Devices Uptime Report',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: true,
    includeSummary: false,
    reportSymbol: 'UTR',
    alarmProtocol: false,
  },
  {
    reportName: 'Devices SIM Report',
    owner: 'System',
    sharingStatus: 'Shared',
    dateRange: false,
    includeSummary: false,
    reportSymbol: 'SIM',
    alarmProtocol: false,
  },
];
class Reports extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken') || null;
    this.state = {
      sort: {
        name: '',
        order: '',
      },
      openModal: false,
      selectedDateRange: '',
      selectedReport: '',
      selctedCompanies: [],
      selectedLocation: '',
      summary: 'no',
      downloadType: '',
      loading: false,
      includeSummary: false,
      alarmProtocol: false,
      alarmProtocolValue: '',
      reportName: '',
      reportSymbol: '',
      lineTypes: [],
      setUptime: {
        option: 'all',
        value: '',
        time: 'weeks'
      },
      integration: 'all'
    };
  }

  async componentDidMount() {
    const { getCompanies, getCompanyGroups, user } = this.props;
    if (user.role !== 'admin') {
      await getCompanies(this.token, undefined, 'yes');
      await getCompanyGroups(this.token, false, true);
    }
  }

  sortColumnByKey = array => {
    const { sort } = this.state;
    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(
        array,
        [el => el[sortNameArr[0]][sortNameArr[1]][sortNameArr[2]].toLowerCase()],
        [sort.order],
      );
    }
    if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name].toLowerCase()], [sort.order]);
    }
    return orderBy(array, [el => el[sort.name]], [sort.order]);
  };

  onReportPress = (status, summary, name, symbol, alarmProtocol) => {
    this.setState({
      openModal: true,
      selectedReport: status,
      includeSummary: summary,
      reportName: name,
      reportSymbol: symbol,
      alarmProtocol,
    });
  };

  selectedCompany = async companyList => {
    this.setState({ selctedCompanies: companyList });
  };

  lineTypes = types => {
    this.setState({ lineTypes: types });
  };

  selectedLocation = id => {
    this.setState({ selectedLocation: id });
  };

  selectedDates = date => {
    this.setState({ selectedDateRange: date });
  };

  selectAlarmProtocol = data => {
    this.setState({ alarmProtocolValue: data });
  };

  onBoxClick = report => {
    this.onReportPress(
      report.dateRange,
      report.includeSummary,
      report.reportName,
      report.reportSymbol,
      report.alarmProtocol,
    );
  };

  onGenerateReport = async () => {
    const { user } = this.props;
    this.setState({ loading: true });
    const {
      selctedCompanies,
      selectedDateRange,
      selectedLocation,
      summary,
      downloadType,
      reportName,
      reportSymbol,
      includeSummary,
      lineTypes,
      alarmProtocolValue,
      setUptime,
      integration,
    } = this.state;
    const { generateReport } = this.props;
    const companies =
      selctedCompanies.length > 0
        ? selctedCompanies.map(item => item._id)
        : user.role === 'admin' || user.role === 'enterpriseAdmin'
          ? [user.company._id]
          : [];
    await generateReport(
      this.token,
      companies,
      selectedLocation,
      downloadType,
      summary,
      selectedDateRange.fromDate,
      selectedDateRange.toDate,
      reportName,
      reportSymbol,
      lineTypes,
      alarmProtocolValue,
      setUptime,
      integration,
    );
    this.setState({ loading: false });
  };

  render() {
    const {
      sort,
      openModal,
      selectedReport,
      loading,
      includeSummary,
      alarmProtocol,
      reportSymbol,
      alarmProtocolValue,
      reportName,
    } = this.state;
    const { companies, locations, user, companyGroups } = this.props;
    return (
      <div>
        <div className="filter-section">
          <Row>
            <Col md={4} sm={12}>
              {/* <Breadcrumbs /> */}
            </Col>
          </Row>
        </div>{' '}
        <div className="container-fluid epik-boxes" style={{ margin: 0 }}>
          <div className="viewContainer" style={{ marginTop: '20px' }}>
            <>
              <Row>
                <Col md={12}>
                  {reportsList && (
                    <ReportListTable
                      reports={
                        sort.name.length
                          ? reportsList?.length && this.sortColumnByKey(reportsList)
                          : reportsList
                      }
                      onBoxClick={this.onBoxClick}
                    />
                  )}
                </Col>
              </Row>
            </>
          </div>
        </div>
        <PortActivationModal
          loading={loading}
          user={user}
          selectedReport={selectedReport}
          companyGroups={companyGroups}
          includeSummary={includeSummary}
          alarmProtocol={alarmProtocol}
          selectAlarmProtocol={this.selectAlarmProtocol}
          alarmProtocolValue={alarmProtocolValue}
          companies={companies}
          locations={locations}
          selectedCompany={this.selectedCompany}
          selectedDates={this.selectedDates}
          locationId={this.selectedLocation}
          summaryStatus={status => {
            this.setState({ summary: status });
          }}
          downloadType={type => {
            this.setState({ downloadType: type });
          }}
          lineTypes={this.lineTypes}
          isOpen={openModal}
          onCancel={() => {
            this.setState({ openModal: false, selectedCompanies: [], alarmProtocolValue: '' });
          }}
          onConfirm={() => {
            this.onGenerateReport();
          }}
          reportSymbol={reportSymbol}
          reportName={reportName}
          setUptimeOpt={(uptime) => {
            this.setState({ setUptime: uptime });
          }}
          setIntegrationValue={(intgr) => { this.setState({ integration: intgr }) }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.AppState.user,
    boxes: state.AppState.boxes,
    companies: state.AppState.companies,
    companyGroups: state.AppState.companyGroup,
    allBoxes: state.AppState.allBoxes,
    boxesList: state.AppState.boxesList,
    locations: state.AppState.boxDetails.boxLocations,
  };
};

const mapDispatchToProps = dispatch => ({
  getEpikBoxesData: (token, companyId, online, unmonitored, disablePagination, pagination) =>
    dispatch(
      getEpikBoxesData(token, companyId, online, unmonitored, disablePagination, pagination),
    ),
  getEpikBoxesDetail: (token, companyId, pagination) =>
    dispatch(getEpikBoxesDetail(token, companyId, pagination)),
  getCompanies: (token, pagination, disabledPagination) =>
    dispatch(getCompanies(token, pagination, disabledPagination)),
  getLocationByCompany: (token, cid) => dispatch(getLocationByCompany(token, cid)),
  generateReport: (
    token,
    cid,
    lid,
    type,
    summary,
    fromDate,
    toDate,
    selectedReport,
    symbol,
    lineTypes,
    alarmProtocolValue,
    setUptime,
    integration,
  ) =>
    dispatch(
      generateReport(
        token,
        cid,
        lid,
        type,
        summary,
        fromDate,
        toDate,
        selectedReport,
        symbol,
        lineTypes,
        alarmProtocolValue,
        setUptime,
        integration,
      ),
    ),
  getCompanyGroups: (token, pagination, format) =>
    dispatch(getCompanyGroups(token, pagination, format)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Reports));
